// extracted by mini-css-extract-plugin
export var container = "_fg-1";
export var cornerButtonContainer = "_fg-6";
export var disabled = "_fg-2";
export var dragActive = "_fg-3";
export var fileContainer = "_fg-5";
export var hiddenInput = "_fg-4";
export var widthContainer = "_fg-0";